<template>
  <div
    ref="noticeIndex"
    class="board-notice"
    :class="{ 'board-scrolled': detectDownScrollTrigger }"
  >
    <TopBarBackTitle
      :title="$t('setting.notice')"
      :trigger="detectDownScrollTrigger"
    />
    <div class="board-notice-body mx-16">
      <div
        v-for="(notice, index) in noticeData"
        :key="notice.boardId"
        class="notice flex flex-space-between mb-default mx-auto"
        @click="useCommon().navigate(`/board/notice/${notice.boardId}`, partnersKey)"
      >
        <div class="notice-text-group flex flex-column flex-justify-center">
          <p class="notice-title">{{ notice.title }}</p>
          <p class="notice-description">{{ notice.createAt }}</p>
        </div>
        <nuxt-img
          src="/img/basic-icon/right-arrow.svg"
          width="20"
          height="56"
          alt="notification"
        />
      </div>

      <!-- 감지용 빈 div -->
      <div ref="observerTarget" style="height: 1px;"></div>

      <el-backtop
        target=".board-notice"
        :right="40"
        :bottom="175"
        :visibility-height="10"
      >
        <UpperArrow />
      </el-backtop>
    </div>
  </div>
</template>

<script setup lang="ts">
const { getBoardByNotice } = useApi()
const { dotDateFormat } = useUi()

withDefaults(
  defineProps<{
    partnersKey?: string
  }>(),
  {
    partnersKey: ''
  }
)

const noticeData = ref<BoardData[]>([])
const noticePageCount = ref(1)
const detectDownScrollTrigger = ref(false)
const isLoading = ref(false)
const observerTarget = ref<HTMLElement | null>(null)
const observer = ref<IntersectionObserver | null>(null)

const loadNoticeData = async (additional: boolean) => {
  if (isLoading.value) return
  isLoading.value = true
  if (additional) {
    noticePageCount.value++
  }
  try {
    const res = await getBoardByNotice(noticePageCount.value, 14)
    if (res?.success) {
      const formatted = res.data?.map((notice: BoardData) => ({
        ...notice,
        createAt: dotDateFormat(notice.createdAt)
      }))
      noticeData.value.push(...formatted)
    }
  } finally {
    isLoading.value = false
  }
}

onMounted(() => {
  observer.value = new IntersectionObserver((entries) => {
    if (entries[0].isIntersecting) {
      loadNoticeData(true)
    }
  }, {
    root: null,
    threshold: 0.1
  })

  if (observerTarget.value) {
    observer.value.observe(observerTarget.value)
  }
  loadNoticeData(false)
})

onBeforeUnmount(() => {
  observer.value?.disconnect()
})
</script>
